import { Select } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form/lib/use-form';
import { showNotification } from '@mantine/notifications';
import { useEffect, useState } from 'react';
import { X } from 'tabler-icons-react';
import { getPartnerFilterData } from '../../helpers/filters.helpers';
import useAuth from '../../hooks/useAuth';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { CreateEntity } from '../../type/entity.types';
import { ErrorResponse } from '../../type/error-response.types';
import { EntityFilterData, EntityIdFilterData } from '../../type/filter.types';
import { BasicPartner } from '../../type/select.types';
import useDidMountEffect from '../../hooks/useDidMountEffect';

interface Props {
  filterSelectData: UseFormReturnType<EntityFilterData>;
  filterValues: UseFormReturnType<EntityIdFilterData>;
  error?: React.ReactNode;
}

function SelectPartnerFilter(props: Props) {
  const { filterSelectData, filterValues, error } = props;
  const [isLoading, setIsLoading] = useState(false);
  const axiosPrivate = useAxiosPrivate();
  const noData = 'No data';
  const loadingData = 'Loading...';
  const { auth } = useAuth();

  useEffect(() => {
    const loadPartners = async () => {
      setIsLoading(true);

      const partners = await getPartnerFilterData(axiosPrivate);

      filterSelectData.setFieldValue('partnersData', partners);

      setIsLoading(false);
    };

    loadPartners();

    //so that partners isn't loaded every time component
    //remounts when it comes back from transaction details
    // if (isLoadPartners) {
    //   loadPartners();
    // } else {
    //   setIsLoadPartners(true);
    // }
  }, []);

  useDidMountEffect(() => {
    // Set partner to empty string if the value is falsy
    // This is to prevent the select from showing the previous value
    if (!filterValues.values.partner) {
      filterValues.setFieldValue('partner', '');
    }
  }, [filterValues.values.partner]);

  const getData = () => {
    let data = isLoading
      ? [loadingData]
      : filterSelectData.values.partnersData?.length === 0 ||
        filterSelectData.values.partnersData === undefined
      ? [noData]
      : filterSelectData.values.partnersData;

    return data;
  };

  const getValue = () => {
    let value = isLoading
      ? loadingData
      : filterSelectData.values.partnersData?.length === 0 ||
        filterSelectData.values.partnersData === undefined
      ? noData
      : filterValues.values.partner;

    return value;
  };

  const getDisabled = () => {
    let disabled =
      isLoading || filterSelectData.values.partnersData?.length === 0;

    return disabled;
  };

  return (
    <>
      <Select
        label='Select Partner'
        data={getData()}
        value={getValue()}
        onChange={(value) => {
          const partner = value || '';
          filterValues.setFieldValue('partner', partner);
        }}
        disabled={getDisabled()}
        clearable={!getDisabled()}
        searchable
        error={error}
      />
    </>
  );
}

export default SelectPartnerFilter;
